import * as React from 'react';
import { Box, Tooltip } from '@mui/material';
import { defaultQuoteStatuses } from '@/root/defaultConfiguration';

export const Status = ({ status }: { status: number }) => {
    if (status === null || status === undefined || !defaultQuoteStatuses) return null;
    const statusObject = defaultQuoteStatuses.find((s: any) => +s.value === status);

    if (!statusObject) return null;
    return (
        <Tooltip title={statusObject.label} placement="top">
            <Box
                marginLeft={0.5}
                width={10}
                height={10}
                display="inline-block"
                borderRadius="5px"
                bgcolor={statusObject.color}
                component="span"
            />
        </Tooltip>
    );
};
